export type TipoNotificacao = "erro" | "sucesso";

export interface EventoNotificacaoPayload {
  tipo: TipoNotificacao;
  mensagem: string;
  titulo?: string;
  icone?: React.ReactNode;
  aoFechar?: () => void;
}

export const EVENTO_NOTIFICACAO = "app:notificacao";

export interface ResponseMessage<T = any> {
  mensagem: string;
  codigo?: number;
  status?: T;
}

export const enviaMsgErro = (codigo: number, msg: string): ResponseMessage => {
  return {
    mensagem: msg,
    codigo: codigo,
  };
};

export const enviaMsgSucesso = <T,>(codigo: number, op: string, dados: T): ResponseMessage<T> => {
  return {
    mensagem: `Operação ${op} realizada com sucesso`,
    codigo: codigo,
    status: dados,
  };
};

function emitirNotificacao(payload: EventoNotificacaoPayload) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(EVENTO_NOTIFICACAO, { detail: payload }));
}

export function mostraMensagemErro(message: string, icone?: React.ReactNode, aoFechar?: () => void) {
  const mensagemNormalizada = String(message || "Erro inesperado").trim();
  emitirNotificacao({
    tipo: "erro",
    titulo: "Erro",
    mensagem: mensagemNormalizada,
    icone,
    aoFechar,
  });
}

export function mostraMensagemSucesso(message: string, page?: string) {
  const mensagemNormalizada = String(message || "Operacao realizada com sucesso").trim();
  emitirNotificacao({
    tipo: "sucesso",
    titulo: "Sucesso",
    mensagem: mensagemNormalizada,
  });
}